"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.OtherResidentsPopupWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var reactstrap_1 = require("reactstrap");
var FalconQuestionWidgetBase_1 = require("../../FalconQuestionWidgetBase");
var OtherResidentsPopupWidget = /** @class */ (function (_super) {
    __extends(OtherResidentsPopupWidget, _super);
    function OtherResidentsPopupWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.overLimitFamilyMembers = 6;
        _this.overLimitHousemates = 3;
        _this.changePopupState = false;
        _this.isMaxHousematesExceeded = false;
        _this.toggleShowPopup = function () {
            _this.setState({
                showPopup: !_this.state.showPopup
            }, function () {
                _this.sumLimits = +_this.props.interaction.realEstates[0].adultFamilyMemberCount + +_this.props.interaction.realEstates[0].housemateCount;
                if (_this.overLimitFamilyMembers === +_this.props.interaction.realEstates[0].adultFamilyMemberCount) {
                    _this.props.onStateChange("realEstates[0].adultFamilyMemberCount", undefined);
                }
                else if (_this.overLimitHousemates === +_this.props.interaction.realEstates[0].housemateCount) {
                    _this.props.onStateChange("realEstates[0].housemateCount", undefined);
                }
                else if (_this.sumLimits > 5) {
                    _this.props.onStateChange("realEstates[0].adultFamilyMemberCount", undefined);
                    _this.props.onStateChange("realEstates[0].housemateCount", undefined);
                }
                _this.changelogRecorder.record(_this.props.engine.getInteraction(), "change", "realEstates[0].adultFamilyMemberCount", _this.props.page && _this.props.page.pageId);
                _this.changelogRecorder.record(_this.props.engine.getInteraction(), "change", "realEstates[0].housemateCount", _this.props.page && _this.props.page.pageId);
            });
        };
        _this.preparePopup = function () {
            if (!_this.state.showPopup) {
                _this.changePopupState = !_this.changePopupState;
            }
        };
        _this.checkLimitsToPreparePopup = function () {
            if (_this.props.interaction.realEstates[0].adultFamilyMemberCount !== undefined &&
                _this.props.interaction.realEstates[0].adultFamilyMemberCount !== null &&
                _this.overLimitFamilyMembers === +_this.props.interaction.realEstates[0].adultFamilyMemberCount) {
                _this.isMaxHousematesExceeded = false;
                return true;
            }
            else if (_this.props.interaction.realEstates[0].housemateCount !== undefined &&
                _this.props.interaction.realEstates[0].housemateCount !== null &&
                _this.overLimitHousemates === +_this.props.interaction.realEstates[0].housemateCount) {
                _this.isMaxHousematesExceeded = true;
                return true;
            }
            else if (_this.props.interaction.realEstates[0].adultFamilyMemberCount !== undefined &&
                _this.props.interaction.realEstates[0].adultFamilyMemberCount !== null &&
                _this.props.interaction.realEstates[0].housemateCount !== undefined &&
                _this.props.interaction.realEstates[0].housemateCount !== null) {
                _this.sumLimits = +_this.props.interaction.realEstates[0].adultFamilyMemberCount + +_this.props.interaction.realEstates[0].housemateCount;
                if (_this.sumLimits > 5) {
                    _this.isMaxHousematesExceeded = false;
                    return true;
                }
            }
            return false;
        };
        _this.state = {
            showPopup: false,
        };
        return _this;
    }
    OtherResidentsPopupWidget.prototype.componentDidUpdate = function () {
        if (this.changePopupState) {
            this.changePopupState = !this.changePopupState;
            this.toggleShowPopup();
        }
    };
    OtherResidentsPopupWidget.prototype.renderInputField = function () {
        if (this.props.interaction && this.props.interaction.realEstates) {
            if (this.checkLimitsToPreparePopup()) {
                this.preparePopup();
            }
        }
        return this.state.showPopup && this.renderPopup();
    };
    OtherResidentsPopupWidget.prototype.renderPopup = function () {
        var closeBtn = (0, jsx_runtime_1.jsx)("button", { className: "btn-close", onClick: this.toggleShowPopup });
        return ((0, jsx_runtime_1.jsx)(React.Fragment, { children: (0, jsx_runtime_1.jsxs)(reactstrap_1.Modal, { className: "my-2 info-modal", isOpen: this.state.showPopup, toggle: this.toggleShowPopup, backdrop: "static", children: [(0, jsx_runtime_1.jsx)(reactstrap_1.ModalHeader, { toggle: this.toggleShowPopup, close: closeBtn, children: (0, jsx_runtime_1.jsxs)("div", { className: "d-flex", children: [(0, jsx_runtime_1.jsx)("img", { src: "/img/Flow-attention.svg", alt: "warning-sign" }), (0, jsx_runtime_1.jsx)("span", { className: "ml-3 text-blue-2 fs-20 font-weight-medium", children: "Sorry, we can\u2019t insure you" })] }) }), (0, jsx_runtime_1.jsx)(reactstrap_1.ModalBody, { className: "font-family-base font-weight-extra-light", children: (0, jsx_runtime_1.jsxs)("div", { children: ["We can only insure properties with up to ", (0, jsx_runtime_1.jsx)("b", { className: 'font-weight-semi-bold', children: this.isMaxHousematesExceeded ? "two housemates" : "six adults" }), " living there."] }) }), (0, jsx_runtime_1.jsx)(reactstrap_1.ModalFooter, { children: (0, jsx_runtime_1.jsxs)("div", { className: "w-100 d-flex flex-column justify-content-between", children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(reactstrap_1.Button, { className: "my-2 w-100", color: "btn btn-primary btn-next-no-arrow", onClick: this.toggleShowPopup, children: "OK, I understand" }) }), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(reactstrap_1.Button, { className: "my-2 w-100", color: "btn btn-white", onClick: this.toggleShowPopup, children: "Cancel" }) })] }) })] }) }));
    };
    return OtherResidentsPopupWidget;
}(FalconQuestionWidgetBase_1.FalconQuestionWidgetBase));
exports.OtherResidentsPopupWidget = OtherResidentsPopupWidget;
//# sourceMappingURL=OtherResidentsPopupWidget.js.map